import React from 'react';
import { makeStyles } from 'tss-react/mui';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import UserProfile from '../../stores/models/UserProfile';

const useStyles = makeStyles()(() => ({
    nameInitials: {
        cursor: 'default',
    },
}));

interface UserAvatarProps {
    context?: 'standalone' | 'list';
    profile: UserProfile;
    defaultCursor?: boolean;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ context = 'standalone', profile, defaultCursor }) => {
    // Styling
    const { classes, cx } = useStyles();

    // Properties
    if (context === 'standalone') {
        if (!profile) {
            return <AccountCircleIcon />;
        }

        const photoUrl = profile.picture;

        if (photoUrl) {
            return <Avatar alt="Avatar" src={photoUrl} />;
        }

        if (profile.initials) {
            return (
                <Avatar alt="Avatar">
                    <span className={cx({ [classes.nameInitials]: defaultCursor })}>{profile.initials}</span>
                </Avatar>
            );
        }

        return <AccountCircleIcon />;
    }

    if (context === 'list') {
        if (!profile) {
            return (
                <ListItemAvatar>
                    <Avatar>
                        <PersonIcon />
                    </Avatar>
                </ListItemAvatar>
            );
        }

        const photoUrl = profile.picture;

        if (photoUrl) {
            return (
                <ListItemAvatar>
                    <Avatar alt="Avatar" src={photoUrl} />
                </ListItemAvatar>
            );
        }

        if (profile.initials) {
            return (
                <ListItemAvatar>
                    <Avatar alt="Avatar">
                        <span className={cx({ [classes.nameInitials]: defaultCursor })}>{profile.initials}</span>
                    </Avatar>
                </ListItemAvatar>
            );
        }

        return (
            <ListItemAvatar>
                <Avatar>
                    <PersonIcon />
                </Avatar>
            </ListItemAvatar>
        );
    }

    return null;
};

export default UserAvatar;
